/**
 * @generated SignedSource<<91e9c5e3df548d5fa129e100a12842ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type masq_masqAsUser$data = {
  readonly id: string;
  readonly " $fragmentType": "masq_masqAsUser";
};
export type masq_masqAsUser$key = {
  readonly " $data"?: masq_masqAsUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"masq_masqAsUser">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "masq_masqAsUser"
};

(node as any).hash = "00bacfb68054854fa151ae29568220f3";

export default node;
